module.exports = __webpack_public_path__ + "media/src/assets/icons/ico-sell-35c9f39e15270639359dd6b0bf44c4d9.png";